export const lightPalette = {
    // palette values for light mode
    primary: {
    main: "#313237",
    },
    secondary: {
    main: "#89939A",
    },
    icons: {
    main: "#B4BDC3",
    },
    elements: {
    main: "#E2E6E9",
    },
    bgHover: {
    main: "#FAFBFC",
    },
    white: {
    main: "#fff",
    },
    green: {
    main: "#27AE60",
    },
    red: {
    main: "#EB5757",
    },
    accent: {
    main: "#313237",
    },
    background: {
    default: "#fff",
    paper: "#fff",
    },
    text: {
    primary: "#313237",
    secondary: "#fff",
    },
    success: {
    main: "#27AE60",
    },
    badge: {
    main: "#fff"
    },
    badgeBorder: {
    main: "#fff"
    }
}

export const darkPalette = {
    // palette values for dark mode
    primary: {
      main: "#F1F2F9",
    },
    secondary: {
      main: "#75767F",
    },
    icons: {
      main: "#4A4D58",
    },
    elements: {
      main: "#3B3E4A",
    },
    bgHover: {
      main: "#3B3E4A",
    },
    white: {
      main: "#F1F2F9",
    },
    green: {
      main: "#27AE60",
    },
    red: {
      main: "#EB5757",
    },
    accent: {
      main: "#905BFF",
    },
    background: {
      default: "#0F1121",
      paper: "#161827",
    },
    text: {
      primary: "#F1F2F9",
      secondary: "#75767F",
    },
    badge: {
      main: "#fff"
    },
    badgeBorder: {
      main: "#323542"
    }
}